export default __webpack_public_path__ + "resources/icons/n121-ce5b.png";